import type { ReactNode } from 'react'

/**
 * Nexus data-table card (matches the template's OrderTable/ShopTable chrome):
 * a card with a toolbar row, a horizontally-scrollable table, and a footer.
 */
export default function TableCard({
  toolbar,
  footer,
  children,
}: {
  toolbar?: ReactNode
  footer?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="card bg-base-100">
      <div className="card-body p-0">
        {toolbar && (
          <div className="flex flex-wrap items-center justify-between gap-3 px-5 pt-5">{toolbar}</div>
        )}
        <div className="mt-4 overflow-auto">
          <table className="table">{children}</table>
        </div>
        {footer && (
          <div className="flex flex-wrap items-center justify-between gap-3 p-5 pt-3">{footer}</div>
        )}
      </div>
    </div>
  )
}

/** Toolbar search box styled like the template's `input input-sm` with a leading icon. */
export function TableSearch({
  value,
  onChange,
  placeholder = 'Search…',
}: {
  value: string
  onChange: (v: string) => void
  placeholder?: string
}) {
  return (
    <label className="input input-sm">
      <span className="iconify lucide--search text-base-content/70 size-3.5" />
      <input
        type="search"
        className="w-32 sm:w-48"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
      />
    </label>
  )
}
